import React, {useCallback} from "react";
import styles from "./InterstateOrganisation.module.scss";
import {withRouter} from 'react-router-dom';
import { InterStateContactDetails } from "../../../components/importExport/interStateContactDetails/InterStateContactDetails";
import { useDispatch, useSelector } from "react-redux";
import {storeInterStateDetails, saveImportExportApplication, storeImportExportDetails} from "../../../redux/actions";
import ScrollToTop from "../../../utils/ScrollToTop";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";

const InterstateOrganisation = props => {

  ScrollToTop();
  RedirectIfCaptchaNotSelected(props);

  const dispatch = useDispatch(); 
  const interStateDetails = useSelector(state => state.interStateDetails);
  const importExportDetails = useSelector(state => state.importExportDetails);

  const storeData = (interStateDetails, finished) => {
    
    var newInterStateDetails = {
      ...interStateDetails,
      // step: 1,
      // finished: finished,
      // isIndividualValid: finished
    }

    dispatch(
      storeInterStateDetails(newInterStateDetails)
    );

    const importExportDetailsData = {
      ...importExportDetails,
      interStateDecisionAppTypeStep: 2,
      interStateDecisionAppTypeFinished: finished
    };

   dispatch(storeImportExportDetails(importExportDetailsData));    
  }; 

  const continueButtonHandler = useCallback(
    (interStateData) => { 
      storeData(interStateData, true)
      dispatch(
        saveImportExportApplication("", () => {
            props.history.push(`./organisation-dashboard`);
        })
      );      
    },
    []
  );

  const saveExitButtonHandler  = useCallback(
    (interStateDetails) => {

      storeData(interStateDetails);
      dispatch(
        saveImportExportApplication("", () => {
            props.history.push(`./organisation-dashboard`);
        })
      );
    }, 
    []
  );  

  // const addressTile = importExportDetails.interStateDecisionAppType === 'Organisation' ? 'Business Address' : 'Address'

  return (
      <div className={styles.mainCont}>
        <InterStateContactDetails 
          continueButtonHandler={continueButtonHandler} 
          interStateData={interStateDetails} 
          addressTitle = {`Postal Address (Australian address only)`}
          interStateDecisionAppType = {importExportDetails.interStateDecisionAppType}  
          saveExitButtonHandler = {saveExitButtonHandler} />
      </div>
  );
};

export default withRouter(props => <InterstateOrganisation {...props} />);
